<div class="container d-flex justify-content-center align-items-center min-vh-100">
  <div class="card p-4 shadow rounded-4" style="max-width: 400px; width: 100%;" *ngIf="!viewLoading">
    <h4 class="text-center mb-3">Login</h4>

    <div *ngIf="inValidLogin" class="alert alert-danger text-center">
      Invalid email or password.
    </div>

    <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" novalidate>
      <div class="mb-3">
        <label for="email" class="form-label">Email address</label>
        <input
          type="email"
          id="email"
          class="form-control"
          [ngClass]="{ 'is-invalid': loading && loginForm.get('email').errors }"
          formControlName="email"
          placeholder="name@example.com"
        />
        <div class="invalid-feedback" *ngIf="loading && loginForm.get('email').errors">
          <div *ngIf="loginForm.get('email').errors['required']">Email is required.</div>
          <div *ngIf="loginForm.get('email').errors['email']">Enter a valid email.</div>
        </div>
      </div>

      <div class="mb-3">
        <label for="password" class="form-label d-flex justify-content-between">
          <span>Password</span>
          <a href="#" class="text-decoration-none small">Forgot?</a>
        </label>
        <input
          type="password"
          id="password"
          class="form-control"
          [ngClass]="{ 'is-invalid': loading && loginForm.get('password').errors }"
          formControlName="password"
          placeholder="••••••••"
        />
        <div class="invalid-feedback" *ngIf="loading && loginForm.get('password').errors">
          Password is required.
        </div>
      </div>

      <div class="d-grid mb-3">
        <button type="submit" class="btn btn-primary">Login</button>
      </div>

      <div class="text-center text-muted">
        Don’t have an account? <a href="#">Sign up</a>
      </div>
    </form>
  </div>
</div>
